const fundContainer = document.querySelector('.fund-overview-with-intro')
if(fundContainer){
    const customSelect = document.querySelector('.custom-select');
    const fundRows = document.querySelectorAll('.fund-row');

    // Store current filter value
    let currentFilterValue = 'A';

    // Function to apply filter
    function applyFilter(filterValue) {
        // Update current filter value
        currentFilterValue = filterValue;

        // Show/hide fund rows based on filter
        fundRows.forEach(row => {
            const fundClass = row.dataset.fundClass;

            if (filterValue === 'Alle') {
                row.style.display = '';
            } else {
                // Check if fund name ends with the selected class (A, B, C, etc.)
                const showRow = fundClass === filterValue;
                row.style.display = showRow ? '' : 'none';
            }
        });

        // Show/hide section headers based on visible rows
        document.querySelectorAll('.section-header').forEach(header => {
            const nextRows = [];
            let nextElement = header.nextElementSibling;

            while (nextElement && nextElement.classList.contains('fund-row')) {
                nextRows.push(nextElement);
                nextElement = nextElement.nextElementSibling;
            }

            const hasVisibleRows = nextRows.some(row => row.style.display !== 'none');
            header.style.display = hasVisibleRows ? '' : 'none';
        });
    }

    // Function to check if a row should be visible based on current filter
    function shouldRowBeVisible(row) {
        if (currentFilterValue === 'Alle') {
            return true;
        }
        return row.dataset.fundClass === currentFilterValue;
    }

    // Default select and filter
    function initializeSelect() {
        // Set the default option as selected (A for "Andelsklasse A")
        const defaultOption = customSelect.querySelector('[data-value="A"]');
        if (defaultOption) {
            // Add selected class
            defaultOption.classList.add('selected');

            // Initial filter class A
            applyFilter('A');
        }
    }

    // Initialize on page load
    initializeSelect();

    // Filtering functionality
    customSelect.addEventListener('change', function(e) {
        const filterValue = e.detail.value;
        applyFilter(filterValue);
    });

    // Section header toggle functionality
    document.querySelectorAll('.section-header').forEach(header => {
        header.addEventListener('click', function() {
            const chevron = this.querySelector('.chevron');

            // Get all fund rows in this section
            const sectionRows = [];
            let nextElement = this.nextElementSibling;

            while (nextElement && nextElement.classList.contains('fund-row')) {
                sectionRows.push(nextElement);
                nextElement = nextElement.nextElementSibling;
            }

            // Check if section is currently collapsed
            const isCollapsed = chevron.style.transform.includes('rotate(180deg)');

            if (isCollapsed) {
                // Expand: show only rows that match current filter and rotate chevron back
                chevron.style.transform = 'translateY(-50%) rotate(0deg)';
                sectionRows.forEach(row => {
                    // Only show the row if it matches the current filter
                    if (shouldRowBeVisible(row)) {
                        row.style.display = '';
                    } else {
                        row.style.display = 'none';
                    }
                    row.classList.remove('collapsed');
                });
                this.classList.remove('collapsed');
            } else {
                // Collapse: hide rows and rotate chevron
                chevron.style.transform = 'translateY(-50%) rotate(180deg)';
                sectionRows.forEach(row => {
                    row.style.display = 'none';
                    row.classList.add('collapsed');
                });
                this.classList.add('collapsed');
            }
        });
    });
}